<template>
    <div>
        <div class="checkbox" v-for="item in selection">
            <label>
                <input type="checkbox"
                       v-model="item.IsSelected"
                       v-bind:true-value="true"
                       @change="UpdateSelection"
                       v-bind:false-value="false"> {{item.Object}}
            </label>
        </div>
    </div>
</template>
<script>

    import SelectableObject from "../../helpers/SelectableObject";

    export default {
        props: ['value'],
        data: function () {
            return {
                chartTypes: [
                    "Blank MAR Chart",
                    "Med Profile",
                    "MAR Chart",
                    "Warfarin",
                    "Insulin",
                    "Prn",
                    "Topical Prn",
                    "Topical Daily",
                    "Carehome Reorder",
                    //"Backing Sheet",
                    "Short MAR chart",
                    "Notes Chart"
                ],
                selection : []
            }
        },
        mounted: function () {
            this.selection = [];
            for (var item of this.chartTypes) {
                this.selection.push(new SelectableObject(item, false));
            }
            
        },
        methods: {
            UpdateSelection: function () {
                console.log("Selection Changed")
                var currentSelection = [];
                for (var item of this.selection) {
                    if (item.IsSelected) {
                        currentSelection.push(item.Object)
                    }
                }
                this.$props.value = currentSelection;
                this.$emit('input', currentSelection);
            }
        }
    }
</script>














// WEBPACK FOOTER //
// ChartSelector.scp.html?346728ec